import React from 'react';

export const TextContainer: React.FC = ({ children }) => (
  <div>
    {children}
    <style jsx>{`
      div {
        margin-bottom: 11px;
      }
      @media (min-width: 1024px) {
        div {
          min-height: 100px;
        }
      }
    `}</style>
  </div>
);
